window.rxProductBuild = {};
window.rxProductBuild.options = [];
window.rxProductBuild.frameType = jQuery('[data-remodal-product-title]').data('remodal-product-title');
window.rxProductBuild.steps = ['type-rudy'];
window.rxProductBuild.rxFrameLensShape = jQuery('[name=rxFrameLensShape]:checked').val();
window.rxProductBuild.rxAccountLensShape = jQuery('[name=rxAccountLensShape]:checked').val();
window.rxProductBuild.supply = 'rudy';
window.rxProductBuild.lens_type = 'single';
window.rxProductBuild.originaSubtotal = 0.00;
window.rxProductBuild.subtotal = jQuery('.js-rx-subtotal-details-text').data('subtotal');

const rxDealerSuppliedVariant = '39806621417526',
maxStepCount = jQuery('[data-remodal-step]:last').data('remodal-step-count'),
formData = new FormData();

// Trigger product scroll
productScroll();

// Bypass first step if only 1 option is available
jQuery(document).on('opening', '.remodal', function () {
  bypassStep(1);
  selectOnlyOption();
});

jQuery('[data-remodal-next-step]').on('click', function(e) {
  var nextStep = jQuery(e.target).data("remodal-next-step") || jQuery(e.target).parents().data("remodal-next-step"),
  stepCount = jQuery('[data-remodal-step="' + nextStep + '"]').data("remodal-step-count");

  jQuery('[data-remodal-step]').hide();
  jQuery('[data-remodal-step="' + nextStep + '"]').show();

  jQuery('.js-step-count-text').text('Step ' + stepCount + ' / ' + maxStepCount);

  window.rxProductBuild.steps.push(jQuery(this).data('remodal-next-step'));

  bypassStep(2);
  selectOnlyOption();
});

jQuery('.js-step-count-back').on('click', function() {
  if (window.rxProductBuild.steps.length > 1) {
    window.rxProductBuild.steps.pop();

    jQuery('.rx-cart-builder-wrapper').show();

    var currentStep = jQuery('[data-remodal-step]:visible'),
    backStep = window.rxProductBuild.steps[window.rxProductBuild.steps.length - 1],
    prevStep = jQuery('[data-remodal-step="' + backStep + '"]'),
    stepCount = prevStep.data("remodal-step-count");

    currentStep.hide();
    prevStep.show();

    jQuery('.js-step-count-text').text('Step ' + stepCount + ' / ' + maxStepCount);
  }

});

jQuery('.js-rx-builder-value').on('click change keyup paste', function(e) {
   window.rxProductBuild[e.target.name] = e.target.value;
});

jQuery('.js-rx-builder-options-value').on('change', function(e) {
  if (this.checked) {
    window.rxProductBuild.options.push({ "id": e.target.value, "customDescription": jQuery('[name="rxOptionDescription' + e.target.value + '"]').val() });
  } else {
    window.rxProductBuild.options = window.rxProductBuild.options.filter(function( obj ) {
      return obj.id !== e.target.value;
    });
  }
});

jQuery('.js-rx-builder-options-description-value').on('click change keyup paste', function(e) {
  var id = e.target.name.replace('rxOptionDescription',''),
  index = window.rxProductBuild.options.findIndex(x => x.id === id);

  window.rxProductBuild.options[index].customDescription = jQuery('[name="rxOptionDescription' + id + '"]').val();
});

jQuery('.js-remodal-step-frame .swatches-variant-images-square .option-values .option-value-label').find('input').on('click change', function(e) {
  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label');

    jQuery('.rx-builder .product-image').attr('src', jQuery(this).parents('.option-value-label').find('.option-value-swatch-wrapper').data('variant-image'));

    jQuery('.js-rx-cart-builder-frame-text').text(color);
    jQuery('.js-rx-cart-builder-frame').show();
    jQuery('.js-remodal-step-frame').find('.js-button-primary').show();
  }
});

jQuery('.js-remodal-step-lenses .swatches-variant-images-square .option-values .option-value-label').find('input').on('click', function(e) {

  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label'),
    ltv = jQuery(this).data('product-ltv'),
    contrast = jQuery(this).data('product-contrast'),
    bestFor = jQuery(this).data('product-best-for'),
    lensImage = jQuery(this).parents('.option-value').clone();

    jQuery('.js-rx-cart-builder-lens-text').text(color);
    jQuery('.js-rx-cart-builder-lens').show();
    jQuery('.js-rx-lens-details-ltv').text(ltv);
    jQuery('.js-rx-lens-details-contrast').text(contrast);
    jQuery('.js-rx-lens-details-best-for').text(bestFor);
    jQuery('.js-rx-lens-data').show();
    jQuery('.js-remodal-step-lenses').find('.js-button-primary').show();

    jQuery('.js-rx-lens-data-mobile').remove();
    jQuery('.js-rx-cart-builder-wrapper .js-rx-lens-details .js-rx-lens-data:first').clone().insertAfter(jQuery(this).parents('#slider')).addClass('js-rx-lens-data-mobile').addClass('rx-lens-data-mobile');
  }
});

jQuery('.js-remodal-step-adapter[data-remodal-step="adapter-insert"] .js-rx-adapter-products .swatches-variant-images-square .option-values .option-value-label').find('input').on('click change', function(e) {
  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label');

    jQuery('.js-rx-cart-builder-insert-text').text(color);
    jQuery('.js-rx-cart-builder-insert').show();
    jQuery('.js-remodal-step-adapter').find('.js-button-primary').show();
  }
});

jQuery('.js-remodal-step-adapter[data-remodal-step="adapter-dock"] .js-rx-adapter-products .swatches-variant-images-square .option-values .option-value-label').find('input').on('click change', function(e) {
  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label');

    jQuery('.js-rx-cart-builder-dock-text').text(color);
    jQuery('.js-rx-cart-builder-dock').show();
    jQuery('.js-remodal-step-adapter').find('.js-button-primary').show();
  }
});

jQuery('.js-remodal-step-options .swatches-variant-images-square .option-values .option-value-label').find('input').on('click change', function(e) {
  jQuery('.js-remodal-step-options').find('.js-button-primary').show();
});

jQuery('.js-remodal-step-type-rudy, [data-remodal-step="adapter-choice"]').find('.js-rx-builder-value').on('click', function(e) {
  destroyCart();
});

jQuery('.js-remodal-step-frame .swatches-variant-images-square .option-values .option-value-label input').on('click change', function(e) {
  window.rxProductBuild.frame = jQuery(e.target).val();
  window.rxProductBuild.frame_price = getSelectedProductPrice(e);
  updateSubtotal();
});

jQuery('.js-remodal-step-lenses .swatches-variant-images-square .option-values .option-value-label input').on('click change', function(e) {
  window.rxProductBuild.lenses = jQuery(e.target).val();
  window.rxProductBuild.lens_price = getSelectedProductPrice(e);
  updateSubtotal();
});

jQuery('.js-remodal-step-adapter .js-rx-adapter-products .swatches-variant-images-square .option-values .option-value-label input').on('click change', function(e) {
  window.rxProductBuild.adapter = jQuery(e.target).val();
  window.rxProductBuild.adapter_price = getSelectedProductPrice(e);
  updateSubtotal();
});

jQuery('.js-remodal-step-options .js-rx-options-coatings-variant .option-values .option-value-label input').on('click change', function(e) {
  window.rxProductBuild.coating_lenses = jQuery(e.target).val();
  window.rxProductBuild.coating_lenses_price = getSelectedProductPrice(e);
  updateSubtotal();

  if (jQuery(this).is(":visible")) {
    var coating = jQuery(this).attr('aria-label');

    jQuery('.js-rx-options-details-options-coatings-text').text(coating);
    jQuery('.js-rx-options-details-options-coatings').show();
  }
});

jQuery('.js-remodal-step-options .js-rx-options-mirrors-variant .option-values .option-value-label input').on('click change', function(e) {
  window.rxProductBuild.mirror_lenses = jQuery(e.target).val();
  window.rxProductBuild.mirror_lenses_price = getSelectedProductPrice(e);
  updateSubtotal();

  if (jQuery(this).is(":visible")) {
    var mirror = jQuery(this).attr('aria-label');

    jQuery('.js-rx-options-details-options-mirrors-text').text(mirror);
    jQuery('.js-rx-options-details-options-mirrors').show();
  }
});

jQuery('.js-remodal-step-adapter[data-remodal-step="adapter-dock"] .js-rx-adapter-with-frame-products .swatches-variant-images-square .option-values .option-value-label input').on('click change', function(e) {
  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label');

    jQuery('.rx-builder .product-image').attr('src', jQuery(this).parents('.option-value-label').find('.option-value-swatch-wrapper').data('variant-image'));

    jQuery('.js-rx-cart-builder-frame-text').text(color);
    jQuery('.js-rx-cart-builder-frame').show();
    window.rxProductBuild.frame_with_dock = jQuery(e.target).val();
    window.rxProductBuild.frame_with_dock_price = getSelectedProductPrice(e);
    updateSubtotal();
  }
});

jQuery('.js-remodal-step-adapter[data-remodal-step="adapter-insert"] .js-rx-adapter-with-frame-products .swatches-variant-images-square .option-values .option-value-label input').on('click change', function(e) {
  if (jQuery(this).is(":visible")) {
    var color = jQuery(this).attr('aria-label');

    jQuery('.rx-builder .product-image').attr('src', jQuery(this).parents('.option-value-label').find('.option-value-swatch-wrapper').data('variant-image'));

    jQuery('.js-rx-cart-builder-frame-text').text(color);
    jQuery('.js-rx-cart-builder-frame').show();
     window.rxProductBuild.frame_with_clip = jQuery(e.target).val();
     window.rxProductBuild.frame_with_clip_price = getSelectedProductPrice(e);
     updateSubtotal();
  }
});

jQuery('select[name=pdr], select[name=pdl]').on('change', function(e) {
  var totalPD = +window.rxProductBuild.pdr + +window.rxProductBuild.pdl,
  minPD = jQuery('.js-total-pd').data('rx-min-pd');

  if (jQuery('select[name=pdl]').val() > 0 && jQuery('select[name=pdr]').val() > 0) {
    jQuery('.js-total-pd input').val(totalPD);

      if (minPD > 0 && window.rxProductBuild.type != 'adapter') {
        if (totalPD > minPD) {
          jQuery('.js-min-pd-notice').hide();
          jQuery('.js-rx-script').show();
        } else {
          jQuery('.js-min-pd-notice').show();
          jQuery('.js-rx-script').hide();
        }
      } else {
        jQuery('.js-min-pd-notice').hide();
        jQuery('.js-rx-script').show();
      }
  }
});

jQuery('.js-remodal-step-options input[name=options]').on('change', function(e) {
  if (this.classList.contains('js-rx-custome-text-selection') && this.checked) {
    jQuery('.js-rx-custom-tint-description-' + e.target.value).show();
  } else {
    jQuery('.js-rx-custom-tint-description-' + e.target.value).hide();
  }
});

jQuery('.js-remodal-step-options input[name=mirror]').on('change', function(e) {
  if (this.value == 'true' && this.checked) {
    jQuery('.js-rx-mirror-products').show();
  } else {
    jQuery('.js-rx-mirror-products').hide();
    window.rxProductBuild.mirror_lenses = undefined;
    window.rxProductBuild.mirror_lenses_price = 0;
    updateSubtotal();

    jQuery('.js-rx-options-details-options-mirrors-text').text('');
    jQuery('.js-rx-options-details-options-mirrors-price').text('');
    jQuery('.js-rx-options-details-options-mirrors').hide();
    jQuery('.rx-builder .js-rx-options-mirrors-variant .option-value-label.selected').removeClass('selected');
  }
});

jQuery('.js-remodal-step-adapter input[name=frameWithDock]').on('change', function(e) {
  if (this.value == 'true' && this.checked) {
    jQuery('.js-rx-frame-with-dock-products').show();
  } else {
    jQuery('.js-rx-frame-with-dock-products').hide();
    window.rxProductBuild.frame_with_dock = undefined;
    window.rxProductBuild.frame_with_dock_price = 0;
    updateSubtotal();
  }
});

jQuery('.js-remodal-step-adapter input[name=frameWithClip]').on('change', function(e) {
  if (this.value == 'true' && this.checked) {
    jQuery('.js-rx-frame-with-clip-products').show();
  } else {
    jQuery('.js-rx-frame-with-clip-products').hide();
    window.rxProductBuild.frame_with_clip = undefined;
    window.rxProductBuild.frame_with_clip_price = 0;
    updateSubtotal();
  }
});

// jQuery('[data-remodal-step="frame"] .option-value-swatch-wrapper:not(.disabled)').on('click', function(e) {
//   jQuery('.rx-builder .product-image').attr('src', jQuery(e.target).data('variant-image'));
// });

jQuery('[data-remodal-next-step="distance"], [data-remodal-next-step="adapter-dock-distance"], [data-remodal-next-step="adapter-insert-distance"]').on('click', function(e) {
  if (window.rxProductBuild.type == 'adapter') {
    jQuery('.js-rx-script').show();
    jQuery('[name="od_sph"], [name="os_sph"]').hide();
    jQuery('[name="od_sph"][data-sph-id="' + window.rxProductBuild.adapter + '"], [name="os_sph"][data-sph-id="' + window.rxProductBuild.adapter + '"]').show();
  } else {
    jQuery('.js-rx-script').hide();
    jQuery('[name="od_sph"], [name="os_sph"]').show();
    jQuery('[data-sph-id]').hide();
  }
});

jQuery('[data-remodal-next-step="adapter-insert-progressive"], [data-remodal-next-step="adapter-dock-progressive"], [data-remodal-next-step="progressive"]').on('click', function(e) {
  jQuery('.js-progressive-script').show();
  window.rxProductBuild.lens_type = 'progressive';
});

jQuery('[data-remodal-next-step="adapter-insert-single"], [data-remodal-next-step="adapter-dock-single"], [data-remodal-next-step="single"]').on('click', function(e) {
  jQuery('.js-progressive-script').hide();
  window.rxProductBuild.lens_type = 'single';
});

jQuery('[data-remodal-next-step').on('click', function(e) {
  if (jQuery('[data-remodal-step="info"]').is(':visible')) {
      jQuery('.rx-cart-builder-wrapper').hide();
      jQuery('.js-info-container').empty();
      jQuery('.js-info-container').html(jQuery('.rx-cart-builder-wrapper').clone());
      jQuery('.js-info-container .rx-cart-builder-wrapper').show();
      jQuery('[data-remodal-step="info"]').css("width", "100%").css("float", "none");
      jQuery('.js-info-container .rx-cart-builder-wrapper').css("display", "block").css("width", "100%").css("float", "none").css("border", "none");
  } else {
    jQuery('.rx-cart-builder-wrapper').show();
  }
});

jQuery('[data-remodal-next-step], .js-step-count-back').on('click', function(e) {
  jQuery('.js-rx-options-variant[data-variant-id]').hide();

  if (jQuery('[data-remodal-step="options"]').is(':visible')) {
    if (jQuery('.js-rx-options-variant[data-variant-id="' + window.rxProductBuild.lenses + '"]').length > 0) {
      jQuery('.js-rx-options-variant[data-variant-id="' + window.rxProductBuild.lenses + '"]').show();
    } else {
      jQuery('.js-remodal-step-options').find('.js-button-primary').click();
      window.rxProductBuild.steps.splice(window.rxProductBuild.steps.indexOf('Options'), 1);
    }

    if (jQuery('.js-rx-options-coatings-variant[data-variant-id="' + window.rxProductBuild.lenses + '"]').length <= 0) {
      jQuery('.js-rx-coating-products-inline-choice').hide();
    } else {
      jQuery('.js-rx-coating-products-inline-choice').show();
    }

    if (jQuery('.js-rx-options-mirrors-variant[data-variant-id="' + window.rxProductBuild.lenses + '"]').length <= 0) {
      jQuery('.js-rx-mirror-products-inline-choice').hide();
    } else {
      jQuery('.js-rx-mirror-products-inline-choice').show();
    }
  } else {
    jQuery('.js-rx-options-variant[data-variant-id]').hide();
  }
});

// Filtering

// Check active classes
var resetFilterClass = function() {
  jQuery('.rx-builder .option-value.item').removeClass('filter-item-hide');
};

jQuery('.js-filter-button.all').click( function() {
  resetFilterClass();
});

jQuery('.rx-builder .js-filter-button:not(".all")').click( function() {
  resetFilterClass();
  var activity = jQuery(this).data("filter-activities"),
  lensType = jQuery(this).data("filter-lens-types");

  if (activity != undefined) {
    jQuery(this).parents('.remodal-step').find('.js-filter-product:not([data-product-activities*="' + activity + '"])').parents('.option-value.item').addClass('filter-item-hide');
  }

  if (lensType != undefined) {
    jQuery(this).parents('.remodal-step').find('.js-filter-product:not([data-product-types*="' + lensType + '"])').parents('.option-value.item').addClass('filter-item-hide');
  }
});

jQuery('.rx-builder .option-values .option-value-label').on('click', function(e) {
  if (jQuery(this).is(":visible") && !jQuery(this).hasClass("selected")) {
    jQuery(this).parents('#slider').find('.option-value-label.selected').removeClass('selected');
    jQuery(this).addClass('selected');
  } else if (jQuery(this).parents('.js-remodal-step-options').is(":visible")) {
    jQuery(this).parents('#slider').find('.option-value-label.selected').removeClass('selected');

    window.rxProductBuild.mirror_lenses = undefined;
    window.rxProductBuild.mirror_lenses_price = 0;
    updateSubtotal();
    jQuery('.js-rx-options-details-options-mirrors-text').text('');
    jQuery('.js-rx-options-details-options-mirrors-price').text('');
    jQuery('.js-rx-options-details-options-mirrors').hide();
    jQuery('.rx-builder .js-rx-options-mirrors-variant .option-value-label.selected').removeClass('selected');


    window.rxProductBuild.coating_lenses = undefined;
    window.rxProductBuild.coating_lenses_price = 0;
    updateSubtotal();
    jQuery('.js-rx-options-details-options-coatings-text').text('');
    jQuery('.js-rx-options-details-options-coatings-price').text('');
    jQuery('.js-rx-options-details-options-coatings').hide();
    jQuery('.rx-builder .js-rx-options-coatings-variant .option-value-label.selected').removeClass('selected');
  } else if(jQuery(this).parents('.js-remodal-step-adapter').is(":visible")) {

    window.rxProductBuild.frame_with_clip = undefined;
    window.rxProductBuild.frame_with_clip_price = 0;
    updateSubtotal();
    jQuery('.js-rx-cart-builder-frame-text').text('');
    jQuery('.js-rx-cart-builder-frame-price').text('');
    jQuery('.js-rx-cart-builder-frame').hide();
    jQuery(this).parents('.js-rx-frame-with-clip-products').find('#slider .option-value-label.selected').removeClass('selected');

    window.rxProductBuild.frame_with_dock = undefined;
    window.rxProductBuild.frame_with_dock_price = 0;
    updateSubtotal();
    jQuery('.js-rx-cart-builder-frame-text').text('');
    jQuery('.js-rx-cart-builder-frame-price').text('');
    jQuery('.js-rx-cart-builder-frame').hide();
    jQuery(this).parents('.js-rx-frame-with-dock-products').find('#slider .option-value-label.selected').removeClass('selected');
  }

});

jQuery('.js-rx-options-details-mirrors-remove').on('click change', function(e) {
  window.rxProductBuild.mirror_lenses = undefined;
  window.rxProductBuild.mirror_lenses_price = 0;
  updateSubtotal();
  jQuery('.js-rx-options-details-options-mirrors-text').text('');
  jQuery('.js-rx-options-details-options-mirrors').hide();
  jQuery('.rx-builder .js-rx-options-mirrors-variant .option-value-label.selected').removeClass('selected');
});

jQuery('.js-rx-options-details-coatings-remove').on('click change', function(e) {
  window.rxProductBuild.coating_lenses = undefined;
  window.rxProductBuild.coating_lenses_price = 0;
  updateSubtotal();
  jQuery('.js-rx-options-details-options-coatings-text').text('');
  jQuery('.js-rx-options-details-options-coatings-price').text('');
  jQuery('.js-rx-options-details-options-coatings').hide();
  jQuery('.rx-builder .js-rx-options-coatings-variant .option-value-label.selected').removeClass('selected');
});

// Active tag
jQuery('.rx-builder .filter-button').click(function(){
  jQuery('.rx-builder .filter-button').removeClass('filter-button-active');
  jQuery(this).addClass('filter-button-active');
});

jQuery('#upload').on('change', function() {
  formData.append( 'items[0]properties[upload]' , jQuery('#upload')[0].files[0] );
});

jQuery('.rx-builder-prescription-upload').on('input', function() {
  jQuery('.rx-builder-prescription-upload-success').show();
})

jQuery('.js-rx-add-to-cart').on('click', function(e) {

  var hasErros = false;

  jQuery('.js-input-error').hide();

  if (hasErros == false) {

    if (window.rxProductBuild.frame != undefined) {
      var frameJson = {
        quantity: 1,
        id: window.rxProductBuild.frame,
        properties: {
          'Lens Shape': window.rxProductBuild.rxFrameLensShape
        }
      };
    }

    if (window.rxProductBuild.adapter != undefined) {
      var adapterJson = {
        quantity: 1,
        id: window.rxProductBuild.adapter
      };
    }

    if (window.rxProductBuild.frame_with_dock != undefined || window.rxProductBuild.frame_with_clip != undefined) {
      var frameWithJson = {
        quantity: 1,
        id: window.rxProductBuild.frame_with_dock || window.rxProductBuild.frame_with_clip
      }
    }

    if (window.rxProductBuild.lenses != undefined) {
      var lensesJson = {
        quantity: 1,
        id: window.rxProductBuild.lenses
      };
    }

    formData.append('notes',window.rxProductBuild.patient_name);

    if (window.rxProductBuild.options != undefined) {
      var optionsJson = [];
      jQuery.each(window.rxProductBuild.options, function( index ) {
        optionsJson.push({
          quantity: 1,
          id: window.rxProductBuild.options[index].id,
          properties: {
            'Description': window.rxProductBuild.options[index].customDescription
          }
        });
      });
    }

    if (window.rxProductBuild.mirror == 'true') {
      var mirrorLensesJson = {
        quantity: 1,
        id: window.rxProductBuild.mirror_lenses
      };
    }

    if (window.rxProductBuild.coating_lenses != undefined) {
      var coatingLensesJson = {
        quantity: 1,
        id: window.rxProductBuild.coating_lenses
      };
    }

    if (window.rxProductBuild.supply == 'rudy' && window.rxProductBuild.type == 'frame') {
      var items = [
        frameJson,
        lensesJson,
        optionsJson,
        mirrorLensesJson,
        coatingLensesJson
      ];

      items = postCart(items);
    } else if (window.rxProductBuild.supply == 'rudy' && window.rxProductBuild.type == 'adapter') {
      var items = [
        adapterJson,
        frameWithJson,
        lensesJson,
        optionsJson,
        mirrorLensesJson,
        coatingLensesJson
      ];

      items = postCart(items);
    } else if (window.rxProductBuild.supply == 'account') {
      var items = [
        {
          quantity: 1,
          id: rxDealerSuppliedVariant,
          properties: {
            'Frame': window.rxProductBuild.frameType,
            'Color': window.rxProductBuild.accountFrameColor,
            'Lens Shape': window.rxProductBuild.rxAccountLensShape
          }
        },
        lensesJson,
        optionsJson,
        mirrorLensesJson,
        coatingLensesJson
      ];

      items = postCart(items);
    }
  }
});

function postCart(items) {
  items = items.flat();
  items= items.filter(item => item !== undefined);

  Object.entries(items).forEach(([key, value]) => {
    formData.append('items[' + key + '][id]', value['id']);
    formData.append('items[' + key + '][quantity]', value['quantity']);
  });

  var params = {
    type: 'POST',
    contentType: false,
    processData: false,
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(item) {
      setTimeout(function () { window.location.href = '/cart'; }, 2000);
    }
  };

  // execute ajax add to cart
  jQuery.ajax(params);

  return items;
}

function productScroll() {
  let slider = document.getElementById("slider");
  let next = document.getElementsByClassName("pro-next");
  let prev = document.getElementsByClassName("pro-prev");
  let slide = document.getElementById("slide");
  let item = document.getElementById("slide");

  for (let i = 0; i < next.length; i++) {
    //refer elements by class name

    let position = 0; //slider postion

    prev[i].addEventListener("click", function() {
      //click previos button
      if (position > 0) {
        //avoid slide left beyond the first item
        position -= 1;
        translateX(position); //translate items
      }
    });

    next[i].addEventListener("click", function() {
      if (position >= 0 && position < hiddenItems()) {
        //avoid slide right beyond the last item
        position += 1;
        translateX(position); //translate items
      }
    });
  }

  function hiddenItems() {
    //get hidden items
    let items = getCount(item, false);
    let visibleItems = slider.offsetWidth / 210;
    return items - Math.ceil(visibleItems);
  }
}

function bypassStep(step) {
  var stepPage = jQuery('[data-remodal-step-count="' + step + '"]:visible'),
  advanceValueClass = '.js-rx-builder-value:visible';

  if (stepPage.length == 1) {
    if (stepPage.find(advanceValueClass).length == 1) {
      jQuery(advanceValueClass).click();
    }
  }
}

function selectOnlyOption() {
  if (jQuery('.option-values .option-value.item:visible').length == 1) {
    jQuery('.option-values .option-value.item:visible').find('input').click()
  }
}

function getSelectedProductPrice(e) {
  var price = jQuery(e.target).parent('.option-value-label')
                              .find('.money[data-productprice]:visible')
                              .attr('content');

  return price;
}

function updateSubtotal() {
  var subtotalClass = '.js-rx-subtotal-details-text',
  framePrice = parseFloat(window.rxProductBuild.frame_price) || 0,
  lensPrice = parseFloat(window.rxProductBuild.lens_price) || 0,
  adapterPrice = parseFloat(window.rxProductBuild.adapter_price) || 0,
  coatingLensesPrice = parseFloat(window.rxProductBuild.coating_lenses_price) || 0,
  mirrorLensesPrice = parseFloat(window.rxProductBuild.mirror_lenses_price) || 0,
  frameWithDockPrice = parseFloat(window.rxProductBuild.frame_with_dock_price) || 0,
  frameWithClipPrice = parseFloat(window.rxProductBuild.frame_with_clip_price) || 0;

  window.rxProductBuild.subtotal = framePrice + lensPrice + adapterPrice + coatingLensesPrice + mirrorLensesPrice + frameWithDockPrice + frameWithClipPrice;

  if (window.rxProductBuild.subtotal <= 0) {
    window.rxProductBuild.subtotal = window.rxProductBuild.originaSubtotal;
    jQuery('.js-rx-subtotal').hide();
  } else {
    jQuery('.js-rx-subtotal').show();
  }

  jQuery(subtotalClass).data('subtotal', window.rxProductBuild.subtotal);
  jQuery(subtotalClass).text('$' + window.rxProductBuild.subtotal.toFixed(2));

  updateProductPrices();
}

function updateProductPrices() {
  var subtotalClass = '.js-rx-subtotal-details-text',
  framePrice = parseFloat(window.rxProductBuild.frame_price) || parseFloat(window.rxProductBuild.frame_with_dock_price) || parseFloat(window.rxProductBuild.frame_with_clip_price) || 0,
  lensPrice = parseFloat(window.rxProductBuild.lens_price) || 0,
  adapterPrice = parseFloat(window.rxProductBuild.adapter_price) || 0,
  coatingLensesPrice = parseFloat(window.rxProductBuild.coating_lenses_price) || 0,
  mirrorLensesPrice = parseFloat(window.rxProductBuild.mirror_lenses_price) || 0;

  jQuery('.js-rx-cart-builder-frame-price').text('$' + framePrice);
  jQuery('.js-rx-cart-builder-lens-price').text('$' + lensPrice);
  jQuery('.js-rx-cart-builder-insert-price').text('$' + adapterPrice);
  jQuery('.js-rx-cart-builder-dock-price').text('$' + adapterPrice);
  jQuery('.js-rx-options-details-options-coatings-price').text('$' + coatingLensesPrice);
  jQuery('.js-rx-options-details-options-mirrors-price').text('$' + mirrorLensesPrice);
}

function resetSubtotal() {
  jQuery('.js-rx-subtotal-details-text').data('subtotal', window.rxProductBuild.originaSubtotal);
  jQuery('.js-rx-subtotal-details-text').html(window.rxProductBuild.originaSubtotal.toFixed(2));

  window.rxProductBuild.frame_price = 0;
  window.rxProductBuild.lens_price = 0;
  window.rxProductBuild.adapter_price = 0;
  window.rxProductBuild.coating_lenses_price = 0;
  window.rxProductBuild.mirror_lenses_price = 0;
  window.rxProductBuild.frame_with_dock_price = 0;
  window.rxProductBuild.frame_with_clip_price = 0;

  updateSubtotal();
}

function translateX(position) {
  //translate items
  slide.style.left = position * -210 + "px";
}

function getCount(parent, getChildrensChildren) {
  //count no of items
  let relevantChildren = 0;
  let children = parent.childNodes.length;
  for (let i = 0; i < children; i++) {
    if (parent.childNodes[i].nodeType != 3) {
      if (getChildrensChildren)
        relevantChildren += getCount(parent.childNodes[i], true);
      relevantChildren++;
    }
  }
  return relevantChildren;
}

function destroyCart() {
  jQuery('.js-rx-cart-builder-frame-text').val('');
  jQuery('.js-rx-cart-builder-frame-price').val('');
  jQuery('.js-rx-cart-builder-frame').hide();
  jQuery('.js-rx-cart-builder-insert-text').val('');
  jQuery('.js-rx-cart-builder-insert-price').val('');
  jQuery('.js-rx-cart-builder-insert').hide();
  jQuery('.js-rx-cart-builder-dock-text').val('');
  jQuery('.js-rx-cart-builder-dock-price').val('');
  jQuery('.js-rx-cart-builder-dock').hide();
  jQuery('.js-rx-cart-builder-lens-text').val('');
  jQuery('.js-rx-cart-builder-lens-price').val('');
  jQuery('.js-rx-cart-builder-lens').hide();
  jQuery('.js-rx-cart-builder-options-text').val('');
  jQuery('.js-rx-cart-builder-options-price').val('');
  jQuery('.js-rx-cart-builder-options').hide();
  jQuery('.js-rx-lens-data').hide();
  jQuery('.js-rx-options-details-options-coatings-text').val('');
  jQuery('.js-rx-options-details-options-coatings-price').val('');
  jQuery('.js-rx-options-details-options-coatings').hide();
  jQuery('.js-rx-options-details-options-mirrors-text').val('');
  jQuery('.js-rx-options-details-options-mirrors-price').val('');
  jQuery('.js-rx-options-details-options-mirrors').hide();
  window.rxProductBuild.frame_with_clip = undefined;
  window.rxProductBuild.frame_with_clip_price = 0;
  window.rxProductBuild.frame_with_dock = undefined;
  window.rxProductBuild.frame_with_dock_price = 0;
  resetSubtotal();
}
